// Apolo IDE — Slash command parser (Sprint v2 Epic B5 WS B5.3).
//
// Parses the first line of a composer's text. If it starts with a known
// slash command, returns { name, args }; otherwise null. Composers use
// this before submit to short-circuit normal message sending.

const KNOWN_COMMANDS = new Set(['save']);

/**
 * Parse a slash command from composer text.
 * @param {string} text
 * @returns {{name: string, args: string} | null}
 */
export function parseSlashCommand(text) {
  if (typeof text !== 'string') return null;
  const trimmed = text.trim();
  if (!trimmed.startsWith('/')) return null;
  const firstNewline = trimmed.indexOf('\n');
  const head = firstNewline === -1 ? trimmed : trimmed.slice(0, firstNewline);
  const m = head.match(/^\/([a-zA-Z][a-zA-Z0-9_-]*)\s*(.*)$/);
  if (!m) return null;
  const name = m[1].toLowerCase();
  if (!KNOWN_COMMANDS.has(name)) return null;
  return { name, args: m[2].trim() };
}

export function isKnownCommand(name) {
  return typeof name === 'string' && KNOWN_COMMANDS.has(name.toLowerCase());
}
